import { Grid } from "antd";
import { NAV_TYPE_TOP, SIDE_NAV_WIDTH } from "constants/ThemeConstant";
import { connect } from "react-redux";
import utils from "utils";

const { useBreakpoint } = Grid;

const getLogoWidthGutter = (props, isMobile) => {
  const { navType } = props;
  const isNavTop = navType === NAV_TYPE_TOP ? true : false;
  if (isMobile && !props.mobileLogo) {
    return 0;
  }
  if (isNavTop) {
    return "auto";
  }
  // The header keeps the full brand lockup when the sidebar is collapsed.
  return `${SIDE_NAV_WIDTH}px`;
};

export const Logo = (props) => {
  const isMobile = !utils.getBreakPoint(useBreakpoint()).includes("lg");
  const { logoType } = props;
  return (
    <div className="logo1" style={{ width: `${getLogoWidthGutter(props, isMobile)}` }}>
      <div className={`brand-lockup${logoType === "light" ? " brand-lockup--on-dark" : ""}`}>
        <img className="brand-mark" src="/img/asespsis_icon.png" alt="" />
        <div className="brand-text">
          <div className="brand-name">ASEPSIS</div>
          <div className="brand-tagline">AGED CARE SYSTEMS</div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ theme }) => {
  const { navType } = theme;
  return { navType };
};

export default connect(mapStateToProps)(Logo);
